module.exports = __webpack_public_path__ + "img/live-streaming.821a00b6.svg";